import React from 'react';
import {useNavigate} from 'react-router-dom';
import {authorBio} from '../../content/home/authorBio';
import {homeImageMap} from '../../content/home/homeImages';
import './AuthorBio.css';

function AuthorBio() {
  const navigate = useNavigate();
  const imgSrc = homeImageMap[authorBio.image.key];

  return (
    <div className='abouttheauthor'>
      <div className='py-2 py-lg-5 aboutJaneCorry'>
        <div className='row m-auto align-items-center'>
          <div className='col-md-6 col-lg-7 col-xl-8 col-xxl-9 mt-4 mt-md-0 mt-lg-3'>
            <h3 className='text-center'>{authorBio.heading}</h3>

            <div className='px-2 ps-sm-4 pe-sm-1 px-lg-5 pt-3 pt-md-0 text-center jcdescription'>
              {authorBio.text.map((p, i) => (
                <p key={i}>{p}</p>
              ))}

              <button
                onClick={() => navigate(authorBio.cta.to)}
                className='d-block m-auto mt-3 btnLightDark px-3'>
                {authorBio.cta.label}
              </button>

              <div className='my-4 d-none d-lg-block text-center Newsletterprompt'>
                <button
                  onClick={() => navigate(authorBio.newsletter.to)}
                  className='d-block m-auto buttonLink '>
                  {authorBio.newsletter.buttonLabel}
                </button>
                {authorBio.newsletter.afterText}
              </div>
            </div>
          </div>

          <div className='d-flex col-md-6 col-lg-5 col-xl-4 col-xxl-3 justify-content-center'>
            <img
              src={imgSrc}
              alt={authorBio.image.alt}
              className='img-fluid pt-4 jcimagesmall'
            />
          </div>

          <div className='my-4 d-block d-lg-none Newsletterprompt'>
            <button
              onClick={() => navigate(authorBio.newsletter.to)}
              className='d-block m-auto buttonLink'>
              {authorBio.newsletter.buttonLabel}
            </button>
            <p className='text-center'>{authorBio.newsletter.afterText}</p>
          </div>
        </div>
      </div>
    </div>
  );
}

export default AuthorBio;
